module.exports = __webpack_public_path__ + "static/Artboard-6-3d476a5cac44d335ae191ab6f3df2924.png";